// extracted by mini-css-extract-plugin
export default {"container":"NewMessage_container__gtJwc","expanded":"NewMessage_expanded__qs8QR","newMessage":"NewMessage_newMessage__7yOqq"};